import React from 'react';
import { cn } from '@/lib/utils';
import { COMPLIANCE_LINKS } from '@/constants/complianceLinks';
import { openCookiePreferences } from '@/utils/openCookiePreferences';

type ComplianceLinksProps = {
  className?: string;
  linkClassName?: string;
};

export const ComplianceLinks: React.FC<ComplianceLinksProps> = ({
  className,
  linkClassName,
}) => {
  const handleCookiePreferencesClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    openCookiePreferences();
  };

  return (
    <nav
      aria-label="Compliance"
      className={cn(
        'flex flex-col items-start gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6 sm:gap-y-2',
        className
      )}
    >
      {COMPLIANCE_LINKS.map((link) =>
        link.type === 'cookie-preferences' ? (
          <button
            key={link.label}
            type="button"
            onClick={handleCookiePreferencesClick}
            className={cn(linkClassName, 'bg-transparent border-0 p-0 cursor-pointer')}
          >
            {link.label}
          </button>
        ) : (
          <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {link.label}
          </a>
        )
      )}
    </nav>
  );
};
